import { render } from "./GelirVergisi.vue?vue&type=template&id=70833da3"
import script from "./GelirVergisi.vue?vue&type=script&lang=js"
export * from "./GelirVergisi.vue?vue&type=script&lang=js"

import "./GelirVergisi.vue?vue&type=style&index=0&id=70833da3&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__